import { useMutation } from './useMutation'

export default useMutation
